import { FeatureCollection } from '@turf/turf'
import { MapProvider } from 'react-map-gl/dist/es5'
import { MapGLViewport, ViewportContextProvider } from '../../ViewportContext'
import { GeometryEditorStateProvider } from './GeometryEditorStateContext'
import { GeometryEditorToolsProvider } from './GeometryEditorToolsContext'

export { useGeometryEditorStateContext } from './GeometryEditorStateContext'
export { GeometryEditorToolsContext } from './GeometryEditorToolsContext'

export const GeometryEditorContext: React.FC<{
  resourceId?: string
  initialFeatures?: FeatureCollection
  initialViewport?: MapGLViewport
  displayFields?: boolean
}> = ({ children, resourceId, initialFeatures, initialViewport, displayFields }) => {
  return (
    <MapProvider>
      <ViewportContextProvider initialViewport={initialViewport}>
        <GeometryEditorStateProvider
          resourceId={resourceId}
          initialFeatures={initialFeatures}
          displayFields={displayFields}
        >
          <GeometryEditorToolsProvider>{children}</GeometryEditorToolsProvider>
        </GeometryEditorStateProvider>
      </ViewportContextProvider>
    </MapProvider>
  )
}
